// Ad spend editor — monthly rows, newest first, matching the API. Months sit
// just before the snapshot FIXED_DATE (2025-01-15) so the edit dialog's month
// dropdown (derived from today()) always contains them.
export const AD_SPEND_INLINE_RESPONSES: Record<string, unknown[]> = {
  "/apollo/ad-spend/get-all-ad-spend": [
    {
      adSpendId: "e1f2a3b4-0001-0001-0001-000000000001",
      spendDate: "2024-12-01",
      googleAdsSpendCad: 7250.5,
      microsoftAdsSpendCad: 1430.25,
    },
    {
      adSpendId: "e1f2a3b4-0001-0001-0001-000000000002",
      spendDate: "2024-11-01",
      googleAdsSpendCad: 6800.0,
      microsoftAdsSpendCad: 1275.0,
    },
    {
      adSpendId: "e1f2a3b4-0001-0001-0001-000000000003",
      spendDate: "2024-10-01",
      googleAdsSpendCad: 6120.75,
      microsoftAdsSpendCad: 980.5,
    },
  ],
};
